import { jsx as _jsx } from "react/jsx-runtime";
import { employeeTids } from '../../constants/tids';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
export const SnilsField = ({ value, onValueChange, validationInfo, labelClassName, disabled, }) => {
    return (_jsx(FieldWrapper, { label: "\u0421\u041D\u0418\u041B\u0421", labelClassName: labelClassName, children: _jsx(TrimmedInput, { width: 132, value: value, mask: "999-999-999 99", onValueChange: onValueChange, validationInfo: validationInfo, "data-tid": employeeTids.snilsInput, disabled: disabled }) }));
};
